<app-page-headline
        [breadcrumbTitle]="'Datenschutz'"
        [breadcrumbs]="[
            { label: 'Startseite', link: '/' },
            { label: 'Datenschutz', iconClass: 'fa fa-angle-double-right', link: '/datenschutz' }
        ]"
        [mainTitle]="'Datenschutzerklärung'"
        [subtitle]="'Hier erfahren Sie, wie wir mit Ihren Daten umgehen und diese schützen.'"
        [titleImagePath]="'assets/images/saas1/title-logo.png'"
        [backgroundImage]="'assets/images/saas1/work-bg.png'">
</app-page-headline>
<div class="container my-5">
    <div class="card shadow p-4">
        <h4 class="mb-3">Datenschutzerklärung</h4>

        <h5 class="mt-4">1. Einleitung</h5>
        <p>
            Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Mit dieser Datenschutzerklärung informieren wir Sie darüber, wie und in welchem Umfang auf unserer Website personenbezogene Daten verarbeitet werden. Die Nutzung unserer Website ist grundsätzlich ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis.
        </p>

        <h5 class="mt-4">2. Verantwortliche Stelle</h5>
        <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br>
            <strong>Martin Obrecht</strong><br>
            76137 Karlsruhe<br>
            E-Mail: martin.obrecht(at)palladio.de
        </p>

        <h5 class="mt-4">3. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung</h5>
        <h6 class="mt-3">a) Beim Besuch der Website</h6>
        <p>
            Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert. Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:
        </p>
        <ul>
            <li>IP-Adresse des anfragenden Rechners</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Name und URL der abgerufenen Datei</li>
            <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
            <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers</li>
        </ul>
        <p>
            Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:
        </p>
        <ul>
            <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
            <li>Gewährleistung einer komfortablen Nutzung unserer Website</li>
            <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
            <li>zu weiteren administrativen Zwecken</li>
        </ul>
        <p>
            Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
        </p>

        <h6 class="mt-3">b) Beim Kauf von Firmenlisten und beim Anlegen eines Benutzerkontos</h6>
        <p>
            Wenn Sie eine Firmenliste erwerben oder ein Benutzerkonto anlegen, erheben wir folgende personenbezogene Daten:
        </p>
        <ul>
            <li>Vorname, Nachname</li>
            <li>Firmenname (optional)</li>
            <li>Adresse</li>
            <li>E-Mail-Adresse</li>
            <li>Zahlungsdaten (je nach gewählter Zahlungsmethode)</li>
        </ul>
        <p>
            Die Verarbeitung dieser Daten erfolgt, um Sie als unseren Kunden identifizieren zu können, zur Abwicklung Ihrer Bestellung und zur Korrespondenz mit Ihnen.<br>
            Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b DSGVO.
        </p>

        <h6 class="mt-3">c) Verarbeitung von Unternehmensdaten</h6>
        <p>
            Wir bieten den Kauf von Unternehmensdaten, E-Mail-Adressen und weiteren öffentlich verfügbaren Informationen an. Alle bereitgestellten Firmendaten stammen aus öffentlich zugänglichen Quellen und werden nach bestem Wissen auf ihre Rechtmäßigkeit geprüft. Eine Verarbeitung sensibler personenbezogener Daten findet nicht statt.
        </p>

        <h6 class="mt-3">d) Nutzung von Analyse- und Tracking-Tools</h6>
        <p>
            Wir setzen auf unserer Website Tools ein, um die Nutzung der Website statistisch auszuwerten und unser Angebot zu optimieren (z.B. Google Analytics). Details zur Verwendung und zur Deaktivierung dieser Tools finden Sie weiter unten.
        </p>

        <h5 class="mt-4">4. Weitergabe von Daten</h5>
        <p>
            Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken findet nicht statt.
            Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
        </p>
        <ul>
            <li>Sie Ihre ausdrückliche Einwilligung dazu erteilt haben (Art. 6 Abs. 1 S. 1 lit. a DSGVO)</li>
            <li>die Weitergabe zur Abwicklung von Vertragsverhältnissen mit Ihnen erforderlich ist (Art. 6 Abs. 1 S. 1 lit. b DSGVO)</li>
            <li>für die Weitergabe eine gesetzliche Verpflichtung besteht (Art. 6 Abs. 1 S. 1 lit. c DSGVO)</li>
            <li>die Weitergabe zur Wahrung berechtigter Interessen erforderlich ist und kein Grund zur Annahme besteht, dass Sie ein überwiegendes schutzwürdiges Interesse an der Nichtweitergabe Ihrer Daten haben (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</li>
        </ul>

        <h5 class="mt-4">5. Cookies</h5>
        <p>
            Unsere Website verwendet Cookies. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert. Weitere Informationen finden Sie in unserer Cookie-Richtlinie.
        </p>

        <h5 class="mt-4">6. Ihre Rechte</h5>
        <p>
            Sie haben das Recht:
        </p>
        <ul>
            <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen.</li>
            <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen.</li>
            <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen.</li>
            <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</li>
            <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesebaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen.</li>
            <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen.</li>
            <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren.</li>
        </ul>

        <h5 class="mt-4">7. Widerspruchsrecht</h5>
        <p>
            Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen.
        </p>

        <h5 class="mt-4">8. Datensicherheit</h5>
        <p>
            Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird.
        </p>

        <h5 class="mt-4">9. Aktualität und Änderung dieser Datenschutzerklärung</h5>
        <p>
            Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Mai 2025.<br>
            Durch die Weiterentwicklung unserer Website und Angebote oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
        </p>
    </div>
</div>